import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppRoutes } from '../../enums/app-routes.enum';
import { FirestoreEnum } from '../../enums/firestore-app.enum';
import { ArsenalConfig, Documentation, FirestoreAppConfig } from '../../models/firestore-app-config';

@Component({
  selector: 'app-helper-menu',
  templateUrl: './helper-menu.component.html',
  styleUrls: ['./helper-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-helper-menu',
  },
})
export class HelperMenuComponent implements OnInit {
  items = [];

  constructor(
    private fs: AngularFirestore,
    private router: Router
  ) {}

  private createUrl(route: ActivatedRouteSnapshot) {
    return route.url
      .map(function (s) {
        return s.toString();
      })
      .join('/');
  }

  ngOnInit(): void {
    // subscribe to the NavigationEnd event
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((routeEvent) => {
      this.onRouteEvent();
    });
  }

  private onRouteEvent() {
    let route = this.router.routerState.root.snapshot;

    route = route.firstChild;

    if (route.routeConfig === null) {
      this.items = [];
      return;
    }
    if (!route.routeConfig.path) {
      this.items = [];
      return;
    }
    const url = `${this.createUrl(route)}`;

    const module = this.getFirestoreModule(url);
    if (module) {
      this.getSymAppConfigs$(module).subscribe((docs) => {
        this.items = docs.map((doc) => {
          return {
            label: doc.label,
            url: doc.url,
          };
        });
      });
    } else {
      this.items = [];
    }
  }

  private getFirestoreModule(url: string): FirestoreEnum {
    if (url.includes(AppRoutes.COMPONENTS_PAGE)) {
      return FirestoreEnum.ARSENAL;
    } else if (url.includes(AppRoutes.AEM_PAGE)) {
      return FirestoreEnum.AEM;
    } else if (url.includes(AppRoutes.ENSEMBLE_CONFIG_PAGE)) {
      return FirestoreEnum.ENSEMBLE;
    }

    return null;
  }

  private getSymAppConfigs$(firestoreModule: string): Observable<Array<Documentation>> {
    return this.fs
      .collection(FirestoreEnum.APP_KEY_CONFIGS)
      .doc<FirestoreAppConfig>(FirestoreEnum.ARSENAL)
      .get()
      .pipe(
        map((doc) => {
          return doc.data().appConfigs;
        }),
        map((appConfigs: ArsenalConfig) => {
          return appConfigs.documentation.filter((documentation) => documentation.module === firestoreModule);
        })
      );
  }
}
